import { Map } from "lucide-react";
import {
  LamaPriorityRoadmapParamsSchema,
  defaultLamaPriorityRoadmapParams,
  type LamaPriorityRoadmapOutput,
  type LamaPriorityRoadmapParams,
} from "@playbookai/widget-schemas";
import { lamaParamsEditor } from "../lama-report-params/Editor.js";
import { registerWidget } from "../registry.js";
import type { SqlWidgetDef } from "../types.js";
import { LamaPriorityRoadmapWidget } from "./Component.js";

/**
 * LAMA Priority Roadmap — dashboard-only report section (plan §13.3).
 * `TView` is the `lama/priority-roadmap@1` dataset output.
 */
export const lamaPriorityRoadmapDef: SqlWidgetDef<
  LamaPriorityRoadmapParams,
  LamaPriorityRoadmapOutput
> = {
  kind: "lamaPriorityRoadmap",
  label: "Priority Roadmap",
  modes: ["dashboard"],
  singleton: true,
  defaultSize: { w: 960, h: 400 },
  defaultParams: defaultLamaPriorityRoadmapParams,
  Component: LamaPriorityRoadmapWidget,
  storage: "sql",
  schema: LamaPriorityRoadmapParamsSchema,
  accent: "cyan",
  icon: Map,
  subtitle: "Curated priority areas re-scored from the latest wave",
  defaultRoster: false,
  category: "single",
  layout: { col: "full", row: 7, width: 960, height: 400 },
  dashboard: {
    icon: Map,
    defaultWidth: "full",
    category: "Operations",
    supportsTitleOverride: true,
    EditorForm: lamaParamsEditor("lamaPriorityRoadmap"),
  },
};

registerWidget(lamaPriorityRoadmapDef);
